import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { ShareWindow } from "@/interface/ShareWindow";
import { Button } from "@/shared/ui/Button";

type Props = {
    className?: string;
};

export const ShareButton = ({ className }: Props) => {
    const { t } = useTranslation();
    const handleShareButtonClick = () => {
        NiceModal.show(ShareWindow, { onlyRead: canv.getInitDataProp("onlyRead") });
    };

    return (
        <Button onClick={handleShareButtonClick} size="m" className={className}>
            {t("settings.share")}
        </Button>
    );
};
